import React, { Component } from "react";

import "./index.css";
import DevelopmentTeamTemplate from "./template";

class DevelopmentTeam extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="row m-0 ">
          <div className="col-12 development-team-head-wrap mb-5">
            <h1 style={{ color: "var(--h1Color)" }}>Development Team</h1>
          </div>
        </div>
        <div className="row m-0 ">
          <div className="col-12 devlopment-team-carousel">
            <DevelopmentTeamTemplate />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DevelopmentTeam;
